import { APIS } from "../components/constants/app.constant";
import { getResource, postResource, putResource } from "./axiosService";

export const getEmployee = () => {
  const apiUrl = APIS.EMPLOYEE;
  return getResource(apiUrl);
};

export const updateEmployee = (data: any) => {
  const apiUrl = APIS.EMPLOYEE;
  return putResource(apiUrl, data);
};

export const updateEmpAddress = (data) => {
  const apiUrl = APIS.UPDATE_ADDRESS;
  return putResource(apiUrl, data);
};

export const getOnboardingSteps = () => {
  const apiUrl = APIS.ONBOARDING_STEPS;
  return getResource(apiUrl);
};
export const getPaymentMethod = () => {
  const apiUrl = APIS.GET_AND_UPDATE_PAYMENT_METHOD;
  return getResource(apiUrl);
};

export const createBankAccount = (data) => {
  const apiUrl = APIS.CREATE_AND_GET_BANK_ACCOUNT;
  return postResource(apiUrl, data);
};

export const updatePaymentMethod = (data) => {
  const apiUrl = APIS.GET_AND_UPDATE_PAYMENT_METHOD;
  return putResource(apiUrl, data);
};

export const getBankAccountDetails = () => {
  const apiUrl = APIS.CREATE_AND_GET_BANK_ACCOUNT;
  return getResource(apiUrl);
};
